import { useTheme } from '@/contexts/ThemeContext';
import {
  brandLogoDark,
  brandLogoLight,
  brandSymbol,
  brandGradient,
} from '@/assets/branding';

/**
 * App brand logo with theme awareness.
 *
 * variant:
 *   'auto'     — switches between dark/light logo based on resolvedTheme (default)
 *   'light'    — always white/light logo (use on dark backgrounds, e.g. SplashScreen)
 *   'dark'     — always dark logo (use when background is always light)
 *   'symbol'   — the standalone Kéves symbol mark
 *   'gradient' — gradient version
 */
export default function BrandLogo({
  variant  = 'auto',
  className = 'h-7',
  alt       = 'Kéves App',
  style,
}) {
  const { resolvedTheme } = useTheme();

  const src = {
    auto:     resolvedTheme === 'dark' ? brandLogoLight : brandLogoDark,
    light:    brandLogoLight,
    dark:     brandLogoDark,
    symbol:   brandSymbol,
    gradient: brandGradient,
  }[variant] ?? brandLogoDark;

  return <img src={src} alt={alt} className={className} style={style} />;
}
